import { DateTime } from 'luxon';

import { ONE_MINUTE_IN_MS } from 'src/types/date';

export const UK_TIMEZONE = 'Europe/London';

export type UKDateParts = {
  year: number;
  /** 1-12 (not the 0-11 JS `Date` convention). */
  month: number;
  day: number;
  hour: number;
  minute: number;
  second: number;
};

export function getUKOffsetMs(date: Date): number {
  return (
    DateTime.fromJSDate(date, { zone: UK_TIMEZONE }).offset * ONE_MINUTE_IN_MS
  );
}

export function getUKDateParts(date: Date): UKDateParts {
  const dt = DateTime.fromJSDate(date, { zone: UK_TIMEZONE });
  return {
    year: dt.year,
    month: dt.month,
    day: dt.day,
    hour: dt.hour,
    minute: dt.minute,
    second: dt.second,
  };
}

/** @param month 1-12 (not the 0-11 JS `Date` convention). */
export function getUKWallClockAsUtc(
  year: number,
  month: number,
  day: number,
  hour = 0,
  minute = 0,
  second = 0,
): Date {
  return DateTime.fromObject(
    { year, month, day, hour, minute, second },
    { zone: UK_TIMEZONE },
  ).toJSDate();
}

export function formatUKDate(date: Date): string {
  return DateTime.fromJSDate(date, { zone: UK_TIMEZONE }).toFormat(
    'dd LLL yyyy',
  );
}
